import React from 'react';

const UysotOriginalIcon = () => (
  <svg width="77" height="73" viewBox="0 0 77 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.89551 66.2642C7.89551 62.7203 10.7841 59.8472 14.3474 59.8472H61.6615C65.225 59.8472 68.1135 62.7203 68.1135 66.2642C68.1135 69.8084 65.225 72.6815 61.6615 72.6815H14.3474C10.7841 72.6815 7.89551 69.8084 7.89551 66.2642Z"
      fill="#00A389"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.9628 2.46076C36.4687 -0.0728588 40.5313 -0.0728588 43.0372 2.46076L75.1208 34.8995C77.6264 37.4332 77.6264 41.541 75.1208 44.0744C72.6149 46.6083 68.552 46.6083 66.0461 44.0744L38.5 16.2233L10.9539 44.0744C8.44807 46.6083 4.38527 46.6083 1.8794 44.0744C-0.626467 41.541 -0.626467 37.4332 1.8794 34.8995L33.9628 2.46076Z"
      fill="#00A389"
    />
    <path
      d="M48.3293 42.7493C48.3293 48.254 43.8671 52.7166 38.3629 52.7166C32.8586 52.7166 28.3965 48.254 28.3965 42.7493C28.3965 37.2447 32.8586 32.7822 38.3629 32.7822C43.8671 32.7822 48.3293 37.2447 48.3293 42.7493Z"
      fill="#FFCF9E"
    />
  </svg>
);

export default UysotOriginalIcon;
